// src/hooks/useBlogs.js
import { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'

export const useBlogs = () => {
    const token = localStorage.getItem('kt-auth-react-v.api_token')
    const [offset, setOffset] = useState(0)
    const [fromDate, setFromDate] = useState('')
    const [toDate, setToDate] = useState('')
    const [sortBy, setSortBy] = useState(-1)
    const [searchQuery, setSearchQuery] = useState('')
    const [allData, setAllData] = useState([])
    const [pageCount, setPageCount] = useState(0)
    const [totalItems, setTotalItems] = useState(0)
    const dataPerPage = 10
    const [lgshow, setShow] = useState(false)
    const [blogTitle, setBlogTitle] = useState('')
    const [slug, setSlug] = useState('')
    const [blogDescription, setBlogDescription] = useState('')
    const [blogMetaTitle, setBlogMetaTitle] = useState('')
    const [blogMetaKeywords, setBlogMetaKeywords] = useState('')
    const [blogMetaDescription, setBlogMetaDescription] = useState('')
    const [blogStatus, setBlogStatus] = useState(1)
    const [quillValue, setQuillValue] = useState('')
    const [fileFormatErrorThumbnail, setFileFormatErrorThumbnail] = useState(false)
    const [isEditThumbnail, setIsEditThumbnail] = useState(false)
    const [fileSizeErrorThumbnail, setFileSizeErrorThumbnail] = useState(false)
    const [thumbnail_selected, setThumbnailSelected] = useState('')
    const [thumbNailAlt, setThumbNailAlt] = useState('')
    const [modalTitle, setModalTitle] = useState('View Order Details')
    const [viewMode, setViewMode] = useState(false)
    const [blogId, setBlogId] = useState('')
    const [calenderDates, setCalenderDates] = useState([
        {
            startDate: null,
            endDate: new Date(),
            key: 'selection',
        },
    ])

    const quillRef = useRef()

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sortBy, offset, calenderDates, fromDate, toDate, searchQuery])

    const getData = async () => {
        const res = await axios.get(
            `${process.env.REACT_APP_API_URL}/blogs?from_date=${fromDate}&to_date=${toDate}&sort=${sortBy}&keyword=${searchQuery}&offset=${offset}&limit=${dataPerPage}`,
            { headers: { Authorization: ` ${token}` } },
        )
        const data = res.data
        setAllData(data.blogs)
        setPageCount(Math.ceil(data.total / dataPerPage))
        setTotalItems(data.total)
    }

    const handlePageClick = (event) => {
        const newOffset = event.selected * dataPerPage
        setOffset(newOffset)
    }

    const viewDetails = async (blog_id) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/blogs/${blog_id}`, {
                headers: { Authorization: ` ${token}` },
            })
            if (res.data.statusCode === 200) {
                const data = res.data.blog
                setBlogId(data._id)
                setBlogTitle(data.title)
                setBlogMetaTitle(data.metaTitle)
                setBlogMetaKeywords(data.meta_keywords)
                setBlogMetaDescription(data.meta_description)
                setBlogStatus(data.status)
                setBlogDescription(data.description)
                setSlug(data.slug)
                setThumbNailAlt(data.image_alt)
                setQuillValue(data.content)
                setThumbnailSelected(data.featured_image)
                setIsEditThumbnail(true)
                setViewMode(true)
                handleShow('', 'View Blog', 'View Blog', true)
            } else {
                toast.error('Something went wrong')
            }
        } catch (err) {
            console.log(err)
            toast.error('Something went wrong')
        }
    }

    const handleThumbnail = (e) => {
        setFileSizeErrorThumbnail(false)
        setFileFormatErrorThumbnail(false)

        if (e.target.files[0].size > 300000) {
            setFileSizeErrorThumbnail(true)
            e.target.value = null
            return
        } else {
            if (
                e.target.files[0].type !== 'image/jpeg' &&
                e.target.files[0].type !== 'image/png' &&
                e.target.files[0].type !== 'image/jpg' &&
                e.target.files[0].type !== 'image/svg' &&
                e.target.files[0].type !== 'image/svg+xml' &&
                e.target.files[0].type !== 'image/webp'
            ) {
                setFileFormatErrorThumbnail(true)
                e.target.value = null
                return
            } else {
                setThumbnailSelected(e.target.files[0])
                setIsEditThumbnail(false)
            }
        }
    }

    const handleShow = (e, title = 'View Blog', button = 'View Blog', viewMode = false) => {
        setViewMode(viewMode)
        setModalTitle(title)
        setShow(true)
    }

    const handleClose = () => {
        setBlogId('')
        setBlogTitle('')
        setBlogMetaTitle('')
        setBlogMetaKeywords('')
        setBlogMetaDescription('')
        setBlogStatus(1)
        setThumbNailAlt('')
        setSlug('')
        setQuillValue('')
        setBlogDescription('')
        setThumbnailSelected('')
        setFileSizeErrorThumbnail(false)
        setFileFormatErrorThumbnail(false)
        setIsEditThumbnail(false)
        setViewMode(false)
        setShow(false)
    }

    const handleBlogForm = async (e) => {
        e.preventDefault()
        const formData = new FormData()
        formData.append('title', blogTitle)
        formData.append('metaTitle', blogMetaTitle)
        formData.append('meta_keywords', blogMetaKeywords)
        formData.append('meta_description', blogMetaDescription)
        formData.append('status', blogStatus)
        formData.append('content', quillValue)
        formData.append('description', blogDescription)
        formData.append('photo', thumbnail_selected)
        formData.append('image_alt', thumbNailAlt)
        formData.append('slug', slug)

        const btn = document.getElementById('btn-submit')
        btn.disabled = true
        btn.innerHTML = `
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="visually-hidden">Loading...</span>
        `

        try {
            const url = blogId
                ? `${process.env.REACT_APP_API_URL}/blogs/${blogId}`
                : `${process.env.REACT_APP_API_URL}/blogs`
            const method = blogId ? 'patch' : 'post'

            const res = await axios[method](url, formData, {
                headers: { Authorization: ` ${token}` },
            })

            if (res.data.statusCode === (blogId ? 200 : 201)) {
                handleClose()
                getData()
                toast.success(res.data.message)
            } else {
                toast.error(res.data.message)
            }
        } catch (err) {
            toast.error(err.response?.data?.message || 'Something went wrong!')
        } finally {
            btn.disabled = false
            btn.innerHTML = blogId ? 'Update Blog' : 'Upload New Blog'
        }
    }

    const editBlog = async (blog_id) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/blogs/${blog_id}`, {
                headers: { Authorization: ` ${token}` },
            })
            if (res.data.statusCode === 200) {
                const data = res.data.blog
                setBlogId(data._id)
                setBlogTitle(data.title)
                setBlogMetaTitle(data.metaTitle)
                setBlogMetaKeywords(data.meta_keywords)
                setBlogMetaDescription(data.meta_description)
                setQuillValue(data.content)
                setBlogDescription(data.description)
                setThumbnailSelected(data.featured_image)
                setSlug(data.slug)
                setThumbNailAlt(data.image_alt)
                setIsEditThumbnail(true)
                setBlogStatus(data.status)
                handleShow('', 'Edit Blog', 'Edit Blog', false)
            } else {
                toast.error(res.data.message)
            }
        } catch (err) {
            toast.error('Something went wrong!')
        }
    }

    const deleteBlog = async (blog_id) => {
        try {
            if (window.confirm('Are you sure you want to delete this blog?')) {
                const res = await axios.delete(`${process.env.REACT_APP_API_URL}/blogs/${blog_id}`, {
                    headers: { Authorization: ` ${token}` },
                })
                if (res.data.statusCode === 200) {
                    getData()
                    toast.success(res.data.message)
                } else {
                    toast.error(res.data.message)
                }
            }
        } catch (err) {
            toast.error(err.response?.data?.message || 'Something went wrong!')
        }
    }

    const changeDataRange = (e) => {
        setCalenderDates([e.selection])
        const startdate = new Date(e.selection.startDate)
        const enddate = new Date(e.selection.endDate)
        const startDate = `${startdate.getFullYear()}-${startdate.getMonth() + 1}-${startdate.getDate()}`
        const endDate = `${enddate.getFullYear()}-${enddate.getMonth() + 1}-${enddate.getDate()}`
        setFromDate(startDate)
        setToDate(endDate)
    }

    const imageHandler = () => {
        const input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.setAttribute('accept', 'image/*')
        input.click()

        input.onchange = async () => {
            const file = input.files?.[0]
            if (file) {
                const formData = new FormData()
                formData.append('photo', file)

                try {
                    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/blogs/upload-image`, formData, {
                        headers: {
                            Authorization: ` ${token}`,
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    const quill = quillRef.current.getEditor()
                    const range = quill.getSelection()
                    quill.insertEmbed(range.index, 'image', data.imageUrl)
                } catch (err) {
                    console.error('Image upload failed', err)
                }
            }
        }
    }

    return {
        // State
        offset,
        fromDate,
        toDate,
        sortBy,
        searchQuery,
        allData,
        pageCount,
        totalItems,
        dataPerPage,
        lgshow,
        quillRef,
        blogTitle,
        blogDescription,
        blogMetaTitle,
        blogMetaKeywords,
        blogMetaDescription,
        blogStatus,
        slug,
        quillValue,
        fileFormatErrorThumbnail,
        isEditThumbnail,
        fileSizeErrorThumbnail,
        thumbnail_selected,
        modalTitle,
        viewMode,
        blogId,
        calenderDates,
        thumbNailAlt,

        // Handlers
        setSortBy,
        setSearchQuery,
        handlePageClick,
        viewDetails,
        handleThumbnail,
        handleShow,
        handleClose,
        imageHandler,
        handleBlogForm,
        editBlog,
        deleteBlog,
        changeDataRange,
        setBlogTitle,
        setBlogDescription,
        setBlogMetaTitle,
        setBlogMetaKeywords,
        setBlogMetaDescription,
        setBlogStatus,
        setQuillValue,
        setSlug,
        setThumbNailAlt,
    }
}
